import {DocumentNode} from 'graphql';
import {useLazyQuery} from 'react-apollo';
import {useParams} from 'react-router';

import {ExtractPageInfo} from './types';

export type InfiniteResultsResult = {
  fetchMore: (options: {variables: any}) => void;
  isLoading: boolean;
};

export function useInfiniteResults(
  {
    addListItems,
    extractItems,
    extractPageInfo,
    query,
    updatePageDetails,
  }: {
    addListItems: (newItems: string[]) => void;
    extractItems: (data: any) => string[];
    extractPageInfo: ExtractPageInfo;
    query: DocumentNode;
    updatePageDetails: (hasNextPage: boolean, endCursor: string) => void;
  },
  config: {
    useQueryHook: typeof useLazyQuery;
  } = {
    useQueryHook: useLazyQuery,
  }
): InfiniteResultsResult {
  const {entityName, projectName} = useParams<{
    entityName: string;
    projectName: string;
  }>();

  const [fetchMore, {loading}] = config.useQueryHook(query, {
    onCompleted: data => {
      const newItems = extractItems(data);
      addListItems(newItems);
      const pageData = extractPageInfo(data);
      updatePageDetails(pageData.hasNextPage, pageData.endCursor);
    },
    variables: {
      entityName,
      projectName,
      pattern: '',
      after: '',
      first: 20,
    },
  });

  return {
    fetchMore,
    isLoading: loading,
  };
}
